import dayjs from 'dayjs'
import { Dispatch } from 'redux'

import { Classified, Status } from '../../rest/types/Classified'
import { AdsIntroProps } from '../../components/AdsIntro'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import { google as googleApi } from '../../configuration'
import { getCharacters } from '../../helpers/StringHelpers'
import { actions } from '../../redux'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'
import { BlockCategory } from '../../forms/AdsForm/types'
import { useTheme } from 'styled-components'

export function ClassifiedIntroTransformer({
  classified,
  t,
  isConnected,
  dispatch,
  isSummaryByIa,
}: {
  classified?: Classified
  t?: any
  isConnected?: boolean
  dispatch?: Dispatch
  isSummaryByIa?: boolean
}): AdsIntroProps | undefined {
  const theme = useTheme()
  // Use stored coordinates so the map matches the geocoded location, not Google's guess from the address text
  const mapQuery =
    classified?.lat && classified?.long
      ? `${classified.lat},${classified.long}`
      : classified?.address
  return classified
    ? {
        title: classified?.title ?? '',
        breadcrumb: {
          ...(classified?.classifiedCategory?.name &&
            classified?.postalCode && {
              items: [
                {
                  text: classified?.classifiedCategory?.name,
                  ...(classified?.classifiedCategory?.form ===
                    BlockCategory.Liberal && {
                    href: t('ads_intro_link_href_liberal'),
                    target: '_blank',
                    hoverColor: theme.colors.framboise,
                  }),
                  ...(classified?.classifiedCategory?.form ===
                    BlockCategory.Adopt && {
                    href: t('ads_intro_link_href_adopt'),
                    target: '_blank',
                    hoverColor: theme.colors.framboise,
                  }),
                  ...(classified?.classifiedCategory?.form ===
                    BlockCategory.Job && {
                    href: t('ads_intro_link_href_job'),
                    target: '_blank',
                    hoverColor: theme.colors.framboise,
                  }),
                },
                {
                  text: `${classified?.city} ${getCharacters(
                    classified?.postalCode ?? '',
                    0,
                    2
                  )}`,
                },
                {
                  text: t('ads_intro_update_breadcrumb_id', {
                    id: classified?.numericId,
                  }),
                },
              ],
            }),
        },
        text:
          typeof classified?.summary === 'string' ? classified?.summary : '',
        ...(isSummaryByIa && {
          helpText: t('ads_intro_update_help_text'),
        }),
        map: {
          src: `https://maps.googleapis.com/maps/api/staticmap?center=${mapQuery}&zoom=17&markers=${mapQuery}&size=400x400&key=${googleApi.GOOGLE_MAPS_API_KEY}`,
          alt: t('ads_intro_alt_image_google_map'),
          width: 387,
          height: 391,
          unoptimized: true,
        },
        adsInformation: {
          viewed: t('ads_intro_classified_viewed', {
            views: classified?.views ?? '0',
          }),
          interested: t('ads_intro_classified_interested', {
            interested: classified?.classified_answers?.length,
          }),
          update: `${t('ads_intro_update_classified_date')} ${dayjs(
            classified?.updatedAt
          ).format('DD/MM/YYYY')}`,
        },
        address: classified?.address ?? '',
        link: {
          label: t('ads_intro_link_href_itinerary'),
          href: `https://www.google.com/maps/search/?api=1&query=${mapQuery}`,
          target: '_blank',
        },

        button: {
          type: 'button',
          variant: ActionButtonVariant.quaternary,
          ...((isConnected ||
            classified?.classifiedCategory?.form ===
              BlockCategory.OperatingAid) &&
          classified?.status !== Status.Archived
            ? {
                onClick: () => {
                  dispatch &&
                    dispatch(
                      actions.modals.setAnswerClassifiedModalIsOpen(true)
                    )
                },
                label: t('answer_classified_button_text'),
              }
            : {
                onClick: () => {
                  dispatch &&
                    dispatch(
                      actions.classifieds.setCurrentClassifiedSlug(
                        classified.slug
                      )
                    )
                  Router.pushRoute(routes.loginOrRegister)
                },
                label: t('answer_classified_not_connected_button_text'),
              }),
        },
      }
    : undefined
}
